import { useQuery } from "@tanstack/react-query";
import { BrandService } from "../services/brand.service";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { BRAND_LIST_QUERY_KEY } from "../constants";
import { BackednResponse, IBrand } from "@shared/lib/types";

export function useGetBrandById(brandId: string) {
  const { data, isLoading, isError, error } = useQuery<BackednResponse<IBrand>>(
    {
      queryKey: [...BRAND_LIST_QUERY_KEY, brandId],
      queryFn: () => BrandService.getBrandById(brandId),
      enabled: !!brandId,
    }
  );

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    brand: data?.data,
    isError,
    isFetching: isLoading,
  };
}
